import { Routes } from '@angular/router';
import { applicationsResolver } from './applications.resolver';

export const applicationsRoutes: Routes = [
  {
    path: '',
    resolve: { data: applicationsResolver },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./applications-list/applications-list.component').then(
            (m) => m.ApplicationsListComponent
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./application-detail/application-detail.component').then(
            (m) => m.ApplicationDetailComponent
          ),
        data: { bindToComponentInputs: true },
      },
    ],
  },
];
